import { Get } from "@repo/helpers";

interface SuggestionDto {
	suggestions: AutocompleteItem[];
}

interface AutocompleteItem {
	addressLine1: string;
	addressLine2: string;
	city: string;
	state: string;
	zip: string;
	entries: number;
}

export class AddressApi {
	static async searchAddress(address: string, selected: string, zipCode: string) {
		const params = { address, selected, zipCode };

		// TODO: Should pass the baseapp url in here
		return Get<SuggestionDto>("/api/ACA/Address", "autocomplete", params);
	}
}
